"use client";
import ContactFormOnlyChakaErrors from "components/common/ContactFormOnlyChakaErrors"

import { useState, useRef, useEffect } from "react";
import { useRouter } from "next/router";
import { SiteData, WebsiteTesterProps } from "../src/types/website-tester";
import useLogVisitor from 'hooks/useLogVisitor.js';
import ScreenCanvas from "components/reuseable/test-ScreenCanvas";
import { config } from "components/reuseable/screen-canvas-config";
import Report from "components/reuseable/test-Report";
import dynamic from 'next/dynamic';
import { Director } from 'components/blocks/testimonial';
import { Portfolio2 } from 'components/blocks/portfolio';

import SEO from 'components/common/SEO';
import * as All from 'data/keywords';
import { Footer1 } from "components/blocks/footer";
import ContactFormOnlyChaka4 from "components/common/ContactFormOnlyChaka4";

const LocalDI = dynamic(() => import('components/blocks/seo/Local'), { ssr: false });
const InternationalDI = dynamic(() => import('components/blocks/seo/International'), { ssr: false });

const details = {
    pageName: 'SEOptimist Agency London',
    categories: 'seo, web design',
    description:
        'Transparent, affordable and effective technical SEO services in London for professionals, agencies and enterprise.',
    parentDirectories: ''
};

const WebsiteComponent: React.FC<WebsiteTesterProps> = () => {
    // @ts-expect-error - gen
    const { bgColor, screenshotWidth, screenshotHeight, PADDING, extraVerticalPadding, industrySector } = config;
    useLogVisitor();
    const router = useRouter();
    const [url, setUrl] = useState<string>("");
    const [keywords, setKeywords] = useState<string>("");
    const [fontSize, setFontSize] = useState<number>(34);
    const [siteData, setSiteData] = useState<SiteData | null>(null);
    const [pageSpeedData, setPageSpeedData] = useState<SiteData | null>(null);
    const [pageSpeedDataMobile, setPageSpeedDataMobile] = useState<SiteData | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [showForm, setShowForm] = useState<boolean>(true);
    const imageRef = useRef<HTMLImageElement>(null);
    const [industry, setIndustry] = useState<string>("");
    const [currentMessage, setCurrentMessage] = useState<string>("");
    const [showReport, setShowReport] = useState<boolean>(false);
    const particlesRef = useRef<HTMLDivElement>(null);
    const [dataLoaded, setDataLoaded] = useState({
        siteData: false,
        pageSpeed: false,
        pageSpeedMobile: false
    });
    function createCompletionParticles() {
        const container = particlesRef.current;
        if (!container) return;

        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        for (let i = 0; i < 50; i++) {
            const particle = document.createElement('div');
            particle.classList.add('particle');
            const size = Math.random() * 5 + 2;
            const colors = ['#5d7cff', '#8e54e9', '#ff6b9c', '#ffd166', '#5dff9d'];
            const color = colors[Math.floor(Math.random() * colors.length)];

            Object.assign(particle.style, {
                width: `${size}px`,
                height: `${size}px`,
                background: color,
                borderRadius: '50%',
                left: `${centerX}px`,
                top: `${centerY}px`,
                opacity: '1',
                boxShadow: `0 0 10px ${color}`
            });

            container.appendChild(particle);

            const angle = Math.random() * Math.PI * 2;
            const speed = 1 + Math.random() * 3;
            const vx = Math.cos(angle) * speed;
            const vy = Math.sin(angle) * speed;
            let x = centerX;
            let y = centerY;
            let opacity = 1;

            const animate = () => {
                x += vx;
                y += vy;
                opacity -= 0.02;

                Object.assign(particle.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                    opacity: `${opacity}`
                });

                if (opacity > 0) {
                    requestAnimationFrame(animate);
                } else {
                    particle.remove();
                }
            };

            requestAnimationFrame(animate);
        }
    }

    useEffect(() => {
        const styleId = "custom-inline-style";
        const particlesStyleId = "particles-style";

        // Store original styles before modifying
        const originalBodyStyles = {
            background: document.body.style.background,
            backgroundAttachment: document.body.style.backgroundAttachment
        };

        const navElements = document.querySelectorAll('nav');
        const originalNavStyles = Array.from(navElements).map(nav => ({
            element: nav,
            background: nav.style.background
        }));


        // Prevent duplicate styles
        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.textContent = `
.home.bg-soft-primary .navbar.transparent.navbar-light {
background: transparent
            }                    
                    body {
                        min-height: 100%;
                        background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
                        background-attachment: fixed;
                         line-height: 1.6;
                    } 
 

          
                    .subtitle {
                        font-size: 1.1rem;
                        color: #a0b8ff;
                        max-width: 600px;
                        margin: 0 auto;
                    }

                    .cardy {
                        backdrop-filter: blur(10px);
                        border-radius: 15px;
                        padding: 2rem;
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                        border: 1px solid rgba(100, 120, 255, 0.2);
                        margin-bottom: 2rem;
                    }

                    .form-group {
                        margin-bottom: 1.5rem;
                    }
 
                    input, select {
                        width: 100%;
                        padding: 12px 15px;
                        border-radius: 8px;
                        border: 1px solid rgba(100, 120, 255, 0.3);
                        background: rgba(10, 12, 30, 0.6);
                        color: #fff;
                        font-size: 1rem;
                        transition: all 0.3s ease;
                    }

                    input:focus, select:focus {
                        outline: none;
                        border-color: #5d7cff;
                        box-shadow: 0 0 0 2px rgba(93, 124, 255, 0.3);
                    }

                    .submit-btn {
                        display: block;
                        width: 100%;
                        padding: 14px;
                        background: linear-gradient(to right, #5d7cff, #8e54e9);
                        border: none;
                        border-radius: 8px;
                        color: white;
                        font-size: 1.1rem;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 5px 15px rgba(93, 124, 255, 0.4);
                    }

                    .submit-btn:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 20px rgba(93, 124, 255, 0.6);
                    }

                    .submit-btn:active {
                        transform: translateY(1px);
                    }

                    .submit-btn::after {
                        content: '';
                        position: absolute;
                        top: -50%;
                        left: -50%;
                        width: 200%;
                        height: 200%;
                        background: rgba(255, 255, 255, 0.1);
                        transform: rotate(30deg);
                        transition: all 0.6s ease;
                    }

                    .submit-btn:hover::after {
                        transform: rotate(30deg) translate(20%, 20%);
                    }

                    .loading-container {
                        display: none;
                        text-align: center;
                        padding: 2rem;
                        min-height: 200px;
                        position: relative;
                    }

                    .loading-messages {
                        margin-top: 1.5rem;
                        min-height: 60px;
                    }

                    .loading-message {
                        font-size:1rem;
                        color: #a0b8ff;
                        margin: 1rem 0;
                        opacity: 0;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        transition: opacity 0.5s ease;
                    }

                    .loading-message.active {
                        opacity: 1;
                    }

                    .progress-container {
                        width: 100%;
                        height: 20px;
                        background: rgba(10, 12, 30, 0.6);
                        border-radius: 10px;
                        margin: 2rem 0;
                        overflow: hidden;
                        position: relative;
                        border: 1px solid rgba(100, 120, 255, 0.2);
                    }

                    .progress-fill {
                        height: 100%;
                        width: 0%;
                        border-radius: 10px;
                        background: linear-gradient(90deg, #5d7cff, #8e54e9, #ff6b9c, #ffd166);
                        transition: width 0.5s ease;
                        position: relative;
                        overflow: hidden;
                    }

                    .progress-fill::after {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                        animation: shimmer 2s infinite;
                    }

                    @keyframes shimmer {
                        0% { transform: translateX(-100%); }
                        100% { transform: translateX(100%); }
                    }

                    .particles-container {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                        overflow: hidden;
                    }

                    .particle {
                        position: absolute;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 0.6);
                        opacity: 0;
                    }
 
                `;
            document.head.appendChild(style);
        }

        // Cleanup: remove style if present
        // Cleanup function
        return () => {
            // Remove injected styles
            const injectedStyles = [
                document.getElementById(styleId),
                document.getElementById(particlesStyleId)
            ].filter(Boolean);

            injectedStyles.forEach(style => style?.remove());

            // Restore original body styles
            document.body.style.background = originalBodyStyles.background;
            document.body.style.backgroundAttachment = originalBodyStyles.backgroundAttachment;

            // Restore original nav styles
            originalNavStyles.forEach(({ element, background }) => {
                if (background) {
                    element.style.background = background;
                } else {
                    element.style.removeProperty('background');
                }
            });

            // Remove particles container content
            if (particlesRef.current) {
                particlesRef.current.innerHTML = '';
            }
        };
    }, []);

    // Particle effect for background
    useEffect(() => {
        // if (!showForm) return;

        // Only run on client side
        if (typeof window === 'undefined') return;

        const container = particlesRef.current;
        if (!container) return;

        // Cleanup function
        const cleanup = () => {
            container.innerHTML = '';
            const style = document.getElementById('particles-style');
            if (style) style.remove();
        };

        // Create particles
        const createParticles = () => {
            cleanup(); // Clear existing particles
            const particleCount = 150;

            for (let i = 0; i < particleCount; i++) {
                const particle = document.createElement('div');
                particle.classList.add('particle');
                const size = Math.random() * 3 + 1;
                const posX = Math.random() * 100;
                const posY = Math.random() * 100;
                const delay = Math.random() * 10;
                const duration = 20 + Math.random() * 30;
                const opacity = 0.2 + Math.random() * 0.5;

                Object.assign(particle.style, {
                    width: `${size}px`,
                    height: `${size}px`,
                    left: `${posX}%`,
                    top: `${posY}%`,
                    opacity: `${opacity}`,
                    animation: `float ${duration}s ${delay}s infinite linear`,
                });

                container.appendChild(particle);
            }

            const style = document.createElement('style');
            style.id = 'particles-style';
            style.textContent = `
                nav {background: transparent !important;}
                nav.navbar-clone {display: none !important;}
                @keyframes float {
                    0% { transform: translate(0, 0) rotate(0deg); }
                    100% { transform: translate(${Math.random() * 100 - 50}vw, ${Math.random() * 100 - 50}vh) rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        };

        createParticles();

        // return cleanup;
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        const submitBtn = document.getElementById('submit-btn') as HTMLButtonElement;
        const loadingContainer = document.getElementById('loading')!;
        const progressFill = document.getElementById('progress')!;
        const loadingMessages = [
            'message1', 'message2', 'message3', 'message4', 'message5'
        ].map(id => document.getElementById(id)!);
        //@ts-expect-error -gem
        submitBtn.closest('.card')!.style.display = 'none';

        let progress = 0;
        let currentMessage = 0;

        loadingMessages[currentMessage].classList.add('active');
        loadingContainer.style.display = 'block';

        const interval = setInterval(() => {
            progress += 1;
            progressFill.style.width = `${progress}%`;

            if (progress % 10 === 0) {
                loadingMessages[currentMessage].classList.remove('active');
                currentMessage = (currentMessage + 1) % loadingMessages.length;
                loadingMessages[currentMessage].classList.add('active');
            }

            if (progress >= 100) {
                clearInterval(interval);
                createCompletionParticles();
                setTimeout(() => {
                    loadingContainer.style.display = 'none';
                }, 800);
            }
        }, 900);
        try {
            const keywordsArray = keywords
                .split(",")
                .map(kw => kw.trim())
                .filter(kw => kw.length > 0);

            if (industry && !keywordsArray.includes(industry)) {
                keywordsArray.unshift(industry);
            }

            const res = await fetch("/api/chaka", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    url,
                    keywords: keywordsArray
                })
            });
            // 1) parse the envelope
            const json = await res.json();
            // console.log("📥 raw main elements JSON from API:", json);

            // 2) extract the one domain key
            const hostname = Object.keys(json)[0];
            // console.log("🔑 extracted hostname:", hostname);

            // 3) this is the “result” object your API returned
            const result = json[hostname];
            const screenshotStuff = result.screenshotData[hostname]
            // console.log("⚡️screenshot / elements stuff:", screenshotStuff);
            setShowForm(false);
            setShowReport(true);
            // 6) store that in state 
            setSiteData(screenshotStuff);
            setDataLoaded(prev => ({ ...prev, siteData: true }));
            const fetchPageSpeed = async () => {
                const resPS = await fetch("/api/chaka/pageSpeedAPI", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        url,
                        keywords: keywordsArray
                    })
                });

                const jsonresPS = await resPS.json();
                const hostnameresPS = Object.keys(jsonresPS)[0];
                const resultresPS = jsonresPS[hostnameresPS];
                const pageSpeed = resultresPS.pageSpeedData[hostnameresPS];
                const pageSpeedMobile = resultresPS.pageSpeedDataMobile[hostnameresPS];

                setPageSpeedData(pageSpeed);
                setDataLoaded(prev => ({ ...prev, pageSpeed: true }));
                setPageSpeedDataMobile(pageSpeedMobile);
                setDataLoaded(prev => ({ ...prev, pageSpeedMobile: true }));
            };

            // Fetch without blocking UI
            fetchPageSpeed();

        } catch (err) {
            //@ts-expect-error - gen
            setError(`Error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const sortedElements = [...(siteData?.elements || [])]
        .filter(el => Array.isArray(el.boundingArea) && el.boundingArea.length === 4)
        .sort((a, b) => {
            const [ax1, ay1] = a.boundingArea;
            const [bx1, by1] = b.boundingArea;
            if (typeof ax1 !== 'number' || typeof ay1 !== 'number' || typeof bx1 !== 'number' || typeof by1 !== 'number') {
                return 0;
            }
            return ay1 - by1 || ax1 - bx1;
        });

    const sortedSiteData = siteData ? { ...siteData, elements: sortedElements } : null;


    if (error) {
        return (
            <div className="col-10 col-md-8 col-lg-6 col-xl-5 mx-auto card mt-16">

                <div className="p-5">
                    <h2 className="text-black" style={{ color: "#333" }}>Site Not Loading</h2>
                    <p>The website has failed to load. Have you typed in the full address correctly?
                    </p>
                    <p>It may be that the server where this website is hosted is misconfigured or the security is too high for us to chcek the site. You can <span
                        className="text-primary"
                        style={{ fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => window.location.reload()}
                        role="button"
                        tabIndex={0}
                    >
                        try again
                    </span> or send us an email detailing the issue and we'll send you a manual report.</p></div>
                {/* <button
                    onClick={() => window.location.reload()}
                    className="btn btn-primary btn-send p-2 rounded"
                >
                    Try Again
                </button> */}

                <ContactFormOnlyChakaErrors position="center" siteKey={url} />
            </div>
        );
    }


    return (
        <>
            <SEO
                title={'SEOptimist London - SEO Audit'}
                description={details.description}
                tag={details.categories}
                urlPT={``}
                urlENPT={``}
                url={`${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}`}
                image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}

            />

            <main className="" style={{ height: "100vh" }}>
                {showForm ? (
                    <div className="py-10 px-5">
                        <div
                            className="particles-container"
                            id="particles"
                            ref={particlesRef}
                        ></div>

                        <div className="container-main" style={{
                            maxWidth: 800,
                            margin: "0 auto",
                            position: "relative",
                            zIndex: 8,
                            minHeight: "100%",
                            boxSizing: "border-box"

                        }}>
                            <h1 className="mx-auto mt-10 mb-5" style={{
                                textAlign: "center",

                                fontSize: "2.5rem",
                                marginBottom: "0.5rem",
                                background: "linear-gradient(to right, #4facfe, #00f2fe)",
                                // -webkit-background-clip: "text",
                                backgroundClip: "text",
                                color: "transparent",
                                textShadow: "0 0 10px rgba(79, 172, 254, 0.3)",




                            }}>Test Your Site</h1>
                            <p className="subtitle text-center pb-10" style={{ margin: "0 auto" }}>Use our tool to see a snapshot of what is holding you back in Google, Bing and ChatGPT.</p>
                            <div className="card cardy" style={{
                                backdropFilter: 'blur(10px)',
                                borderRadius: '15px',
                                padding: '2rem',
                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                                border: '1px solid rgba(100, 120, 255, 0.2)',
                                marginBottom: '2rem'
                            }}>
                                <form onSubmit={handleSubmit} className="space-x-2 flex flex-col" >
                                    <label style={{ color: "#666" }} htmlFor="url">Enter your website address</label>
                                    <input

                                        type="text"
                                        value={url}
                                        onChange={(e) => {
                                            let value = e.target.value.toLowerCase();
                                            setUrl(value);
                                        }}
                                        placeholder="https://YourDomain.co.uk"
                                        className="mb-6 form-control"
                                        required
                                        name="url"
                                    />

                                    <label style={{ color: "#666" }} htmlFor="industry">What is your industry?</label>
                                    <input

                                        type="text"
                                        value={industry}
                                        onChange={(e) => setIndustry(e.target.value.toLowerCase())}
                                        placeholder="Enter Industry"
                                        className="mb-6 form-control"
                                        required
                                        name="industry"
                                    />
                                    <label style={{ color: "#666" }} htmlFor="keywords">Keywords you want to rank for (optional)</label>
                                    <input

                                        type="text"
                                        value={keywords}
                                        onChange={(e) => setKeywords(e.target.value.toLowerCase())}
                                        placeholder="Enter Keywords, comma separated"
                                        className="mb-6 form-control"
                                        name="keywords"
                                    />
                                    <button
                                        type="submit"
                                        style={{
                                            width: "100%", background: 'linear-gradient(to right, #5d7cff, #8e54e9)',
                                            transition: 'all 0.3s ease',
                                            boxShadow: '0 5px 15px rgba(93, 124, 255, 0.4)'
                                        }}
                                        className="submit-btn btn btn-primary btn-send mb-3 d-inline-block"
                                        id="submit-btn"
                                    >
                                        Analyse
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="card loading-container" style={{
                            display: 'none',
                            textAlign: 'center',
                            padding: '2rem',
                            minHeight: '200px',
                            position: 'relative'
                        }} id="loading">
                            <h2>Analysing Your Website</h2>
                            <div className="progress-container" style={{
                                width: '100%',
                                height: '20px',
                                background: 'rgba(10, 12, 30, 0.6)',
                                borderRadius: '10px',
                                margin: '2rem 0',
                                overflow: 'hidden',
                                position: 'relative',
                                border: '1px solid rgba(100, 120, 255, 0.2)'
                            }}>
                                <div className="progress-fill" style={{
                                    height: '100%',
                                    width: '0%',
                                    borderRadius: '10px',
                                    background: 'linear-gradient(90deg, #5d7cff, #8e54e9, #ff6b9c, #ffd166)',
                                    transition: 'width 0.5s ease'
                                }} id="progress"></div>
                            </div>
                            <div className="loading-messages">
                                <div className="loading-message" id="message1">Preparing custom site audit...</div>
                                <div className="loading-message" id="message2">Analysing homepage content...</div>
                                <div className="loading-message" id="message3">Checking page load speed...</div>
                                <div className="loading-message" id="message4">Looking for important keywords...</div>
                                <div className="loading-message" id="message5">Reviewing image optimization...</div>
                                <div className="loading-message" id="message6">Checking mobile responsiveness...</div>
                                <div className="loading-message" id="message7">Analysing SEO meta tags...</div>
                                <div className="loading-message" id="message8">Reviewing heading structure...</div>
                                <div className="loading-message" id="message9">Checking for broken links...</div>
                                <div className="loading-message" id="message10">Evaluating content quality...</div>
                                <div className="loading-message" id="message11">Assessing security measures...</div>
                                <div className="loading-message" id="message12">Checking browser compatibility...</div>
                                <div className="loading-message" id="message13">Almost done, compiling report...</div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="mt-13" style={{ backgroundColor: bgColor, width: screenshotWidth + (PADDING * 2), height: screenshotHeight + (PADDING * 2), borderRadius: 8 }}>
                        <div className="relative order-1 order-lg-2">
                            <div className="container pt-3" style={{ textAlign: "center", margin: "0 auto" }}>
                                <div className="">
                                    <h1 className="mt-5" style={{ textAlign: "center", margin: "0 auto 20px", color: "#333" }}>
                                        Report <span style={{ textTransform: "lowercase" }}> for  <em>{url.replace(/https?:\/\/(www\.)?|www\.|\//gi, '')}</em></span>
                                    </h1>
                                    <p className="mx-auto mb-8 d-none d-md-block">

                                        Our advanced analysis dives deep into your site’s code and content to uncover opportunities for improvement.   We give clear reports so you always know what we are doing. We only prioritise SEO tasks that actually make a significant difference to sales. </p>
                                </div>
                            </div>
                            {sortedSiteData && (
                                <>
                                    <ScreenCanvas
                                        //@ts-expect-error - gen
                                        padding={PADDING}
                                        extraVerticalPadding={extraVerticalPadding}
                                        industrySector={industrySector}
                                        domain={url}
                                        siteData={sortedSiteData}
                                        imageRef={imageRef}
                                        screenshotWidth={screenshotWidth}
                                        screenshotHeight={screenshotHeight}
                                    />

                                    {/* @ts-ignore */}
                                    {siteData
                                        && <>
                                            {/* @ts-expect-error */}
                                            <Report siteData={siteData!} pageSpeed={pageSpeedData} pageSpeedMobile={pageSpeedDataMobile} domain={url} />

                                            <div id="full_report" className="mt-n10"></div>
                                        </>

                                    }

                                </>
                            )}
                        </div>
                        <div className="mt-10" >
                            <div style={{ background: "white" }}>
                                <div className="col-10 col-md-8 col-lg-6 col-xl-5 mx-auto pt-10">

                                    <ContactFormOnlyChaka4 siteKey={url} position="center" /></div>
                            </div></div> <Portfolio2 title={`${All.HomeList[7].title}s`} />

                        <Director title={All.HomeList[6].title} />
                        {/* ========== INTERNATIONAL SEO section ========== */}

                        <LocalDI
                            heading={All.localSEOPackages[1].title}
                            initialslide={0}
                            body="Our local & Technical SEO, Social & PPC services target your exact demographic in the UK."
                        />
                        <InternationalDI
                            heading={`${All.HomeList[9].title}s`}
                            body={`Our ${All.HomeList[9].title}s have developed SEO straegies and multilingual software for the biggest tech companies in
                    the USA. We apply the same strategies to make your site visible in searches for European keywords.`}
                        />
                        <div className="col-10 col-md-8 col-lg-6 col-xl-5 mx-auto pt-10">

                            <ContactFormOnlyChaka4 siteKey={url} position="center" />
                        </div>
                        <Footer1
                            address={[
                                <>
                                    {All.SiteIdentity[0].address1},<br /> {All.SiteIdentity[0].address2},<br />{' '}
                                    {All.SiteIdentity[0].address3}
                                </>
                            ]}
                            email={All.SiteIdentity[0].email}
                            phone={All.SiteIdentity[0].phone}
                        />
                    </div>
                )}
            </main>
        </>
    );
};
//@ts-expect-error - gen
WebsiteComponent.bodyClass = 'transparent';

export default WebsiteComponent;